import { gql } from '@/utilities/gql';
import { makeGqlMutation } from '@/utilities/gqlQuery';

const QUERY = gql(`
  mutation GenerateNarrativeTitleSuggestion($input: NarrativeTitleSuggestionsInput!, $limit: Float!) {
    generateNarrativeTitleSuggestions(input: $input, limit: $limit) {
      titles
    }
  }
`);

export const useGenerateNarrativeTitle = makeGqlMutation(QUERY);
